export interface IRole{
    IsSystemRole: boolean;
    RoleGroupId: number;
    RoleId: number;
    RoleName: string;
}